import classNames, { ClassValue } from 'classnames'
import React from 'react'
import { Intent } from '../../types/badges'

interface BaseBadgeProps {
    options: { [key: string | number]: { text: string; intent: Intent } }
    value: string | number
    className?: ClassValue
    suffix?: string
}

export const BaseBadge = ({ options, value, className, suffix }: BaseBadgeProps) => {
    if (!options[value]) {
        console.error('Cannot resolve badge for', value, 'from', options)
        return null
    }

    const { intent, text } = options[value]
    return (
        <span
            className={classNames(className, 'bp4-tag bp4-minimal', {
                'bp4-intent-primary': intent === 'primary',
                'bp4-intent-success': intent === 'success',
                'bp4-intent-warning': intent === 'warning',
                'bp4-intent-danger': intent === 'danger',
                'bp4-intent-split-warning-success': intent === 'split-warning-success',
                'bp4-intent-split-default-success': intent === 'split-default-success',
            })}
        >
            {text}
            {suffix ? ' ' + suffix : ''}
        </span>
    )
}
